import { debug } from "@/log";

const usedFonts: string[] = [];


export function addFont(fontFamily: string) {

  if (!fontFamily) { return; }

  // strip fontFamily

  let firstFont = fontFamily.split(',')[0];
  firstFont = firstFont.replaceAll('"', '');
  firstFont = firstFont.replaceAll("'", '');

  fontFamily = firstFont;
  // check for already having one
  if (usedFonts.find(p => p == fontFamily) != null) { return; }
  usedFonts.push(fontFamily);
  // add link
  debug("Link to font by Google " + fontFamily);

  const link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';

  //link.href = 'http://fonts.googleapis.com/css?family=Oswald&effect=neon';
  document.head.appendChild(link);
  link.href = 'https://fonts.googleapis.com/css?family=' + fontFamily;


}
